import axios from 'axios';
import { axiosInstance } from '../axios-instance';
import {
  ILoginRequest,
  ILoginResponse,
  IForgotPasswordRequest,
  IForgotPasswordResponse,
  type IResetPasswordRequest,
  type IResetPasswordResponse,
} from './types';

export const login = async (params: ILoginRequest): Promise<ILoginResponse> => {
  return axiosInstance.post('/authentication/login', params, {
    withCredentials: true,
  });
};

export const signout = async (): Promise<void> => {
  return axiosInstance.post(
    '/authentication/signout',
    {},
    {
      withCredentials: true,
    }
  );
};

export const forgotPassword = async (
  params: IForgotPasswordRequest
): Promise<IForgotPasswordResponse> => {
  return axiosInstance.post('/authentication/forgot-password', params, {
    withCredentials: true,
  });
};

export const resetPassword = async (
  params: IResetPasswordRequest
): Promise<IResetPasswordResponse> => {
  return axiosInstance.post('/authentication/reset-password', params, {
    withCredentials: true,
  });
};

export const getAccessTokenByApi = () => {
  const url = `${import.meta.env.VITE_API_URL}/authentication/access`;

  return axios.post<{
    data: {
      token: string;
      refreshToken: string;
    };
  }>(
    url,
    {},
    {
      headers: {
        isPublic: true,
      },
      withCredentials: true,
      params: {},
    }
  );
};
